module.exports = __webpack_public_path__ + "static/media/BDD_SetUpScreens_Rides.97f6aae5.png";